import ContentFolderListing from '@/components/content-folder-listing';
import type { PageWithComponentData } from 'src/lib/page-designer/page-loader.server';
import type { FolderListingRouteData, NewsListingRouteData } from './types';

export function FolderListingRoute({
    data,
    page,
    kind,
}: {
    data: FolderListingRouteData | NewsListingRouteData;
    page?: PageWithComponentData;
    kind: 'folderListing' | 'newsListing';
}) {
    return (
        <>
            <ContentFolderListing
                page={page}
                kind={kind}
                folder={data.folder}
                criticalSearchResult={data.criticalSearchResult}
                nonCriticalSearchResult={data.nonCriticalSearchResult}
                subCategoryLinks={data.subCategoryLinks}
                currentPage={data.currentPage}
                limit={data.limit}
                initialFiltersOpen={data.initialFiltersOpen}
                initialOrdinationOpen={data.initialOrdinationOpen}
                sortingOptionIds={data.sortingOptionIds}
            />
        </>
    );
}
